import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggerService } from '../services/logger.service';
import { GlobalModalService } from '../shared/global-modal/global-modal.service';
import { ErrorService } from '../services/error.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private injector: Injector) {}

  handleError(error: any): void {
    const logger = this.injector.get(LoggerService);
    const modal = this.injector.get(GlobalModalService);
    const errorService = this.injector.get(ErrorService);

    const message = errorService.extractMessage(error) || 'Se ha producido un error inesperado.';
    logger.error('Uncaught Error', error);
    modal.showError('Error inesperado', message);
    // No re-lanzamos para evitar bucles de error en UI
  }
}
